/** The view-as tab: where it starts (/impersonate#token), the banner while it lasts, and the page when it ends. */
import { useState } from 'react';
import { api } from '../lib/api';
import { viewAs } from '../lib/impersonation';
import { useMe } from '../lib/session';

const ROLE: Record<string, string> = {
  HR_ADMIN: 'HR admin',
  TEAM_LEAD: 'team lead',
  PROJECT_MANAGER: 'project manager',
  STAFF: 'staff',
};

/** /impersonate without a token (it was taken at start-up, see captureViewAs): the view-as tab has ended. */
export function ImpersonationEnded() {
  return (
    <div className="wrap">
      <div className="panel impend">
        <h2>This view-as tab has ended</h2>
        <p>It was ended, expired, or your own session ended. Nothing you did here changed anything.</p>
        <div className="acts">
          <button type="button" className="btn primary" onClick={() => window.close()}>
            Close this tab
          </button>
          <button type="button" className="btn" onClick={() => location.replace('/')}>
            Open my own report
          </button>
        </div>
      </div>
    </div>
  );
}

/** Shown on every page of a view-as tab. */
export function ImpersonationBanner() {
  const me = useMe();
  const [busy, setBusy] = useState(false);
  if (!me.data?.impersonatedBy) return null;
  const end = async () => {
    setBusy(true);
    try {
      await api('/api/impersonation/end', { method: 'POST' });
    } catch {
      /* already over */
    }
    viewAs.clear();
    window.close();
    // Browsers only close tabs that scripts opened; otherwise show the ended page.
    setTimeout(() => location.replace('/impersonate#ended'), 300);
  };
  return (
    <div className="impbar" role="status">
      <span>
        👁 Viewing as <b>{me.data.displayName}</b> ({ROLE[me.data.role] ?? me.data.role}): exactly what they see.
        Read-only; nothing can be changed here.
      </span>
      <button type="button" className="btn small" disabled={busy} onClick={() => void end()}>
        End and close
      </button>
    </div>
  );
}
